import { render } from "./Patient.vue?vue&type=template&id=463e149d&scoped=true"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"

import "./Patient.vue?vue&type=style&index=0&id=463e149d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463e149d"]])

export default __exports__